<template>
  <v-app id="inspire">

    <v-app-bar app clipped-left color="primary" dark >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-img src="../assets/logo2.png" alt="" width="1%" height="100%"></v-img>
      <v-toolbar-title>Hola Jose</v-toolbar-title>
        <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click.stop="drawerRight = !drawerRight"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer v-model="drawerRight" app right>
      <v-list dense>
        <v-list-item class="d-flex justify-center">
          <v-avatar  size="100">
            <img src="../assets/user.png" alt="Asesoratech">
          </v-avatar>
        </v-list-item>
        <br>
        <v-list-item @click="change()">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Cambiar Tema</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="change()">
          <v-list-item-action>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>


    <v-navigation-drawer v-model="drawer" app clipped left>
      <v-list dense>
        
        <v-list-item class="d-flex justify-center">
          <v-avatar  size="100">
            <img src="../assets/logo.png" alt="Asesoratech">
          </v-avatar>
        </v-list-item>
        <v-list-item>
              <v-row dense>
                <v-col cols="12">
                  <v-card color="#385F73" dark >
                    <v-card-subtitle>Tareas Pendientes: 1</v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
        </v-list-item>
        <v-list-item @click.stop="left = !left">
          <v-list-item-action>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Izquierdo</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
      <v-container fluid>
        <v-row>
          <v-col>
            <PieChart/>
          </v-col>
        </v-row>
      </v-container>
    <!--<v-navigation-drawer v-model="right" fixed right temporary ></v-navigation-drawer>-->
  </v-app>
</template>

<script>
import api from '../conf/ruta-base';
import PieChart from '../components/line-charts';
console.log(api);
  export default {
    name:'Otro',
    components: {
      PieChart
    },
    props: {
      source: String,
    },
    data: () => ({
      drawer: true,
      drawerRight: false,
      right: false,
      left: false,
      chartData: {
        Enero: 24,
        Febrero: 30,
        Marzo: 10
      }
    }),
    created () {
      //this.$vuetify.theme.dark = false
    },
    methods: {
      change() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      }
    },
  }
</script>
